import Input from '@/components/Input';
import { FiSearch } from '@/components/react-icons/main';
import setQuery from '@/lib/setQuery.js';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import { query } from '@/redux/selectors/querySelectors.js';

const PageSearch = ({ inputRef, placeholder, searchKey = 'search', disabled, ...props }) => {
  const searchValue = decodeURIComponent(useArgSelector(query, searchKey) || '').replace(/\+/g, ' ');

  const handleSearch = (e) => {
    setQuery({ [searchKey]: e.target.value || null });
  };

  const handleClear = () => {
    setQuery({ [searchKey]: null });
  };

  return (
    <Input //
      ref={inputRef}
      className={'rounded-md'}
      icon={FiSearch}
      value={searchValue}
      onChange={handleSearch}
      onClear={handleClear}
      placeholder={placeholder || 'Search'}
      disabled={disabled}
      {...props}
    />
  );
};

export default PageSearch;
